import { domain as parent } from '../domain'

export const domain = parent.domain('Model')
